import { render, staticRenderFns } from "./TimeLineProfessor.vue?vue&type=template&id=dcc28272&"
import script from "./TimeLineProfessor.vue?vue&type=script&lang=js&"
export * from "./TimeLineProfessor.vue?vue&type=script&lang=js&"
import style0 from "./TimeLineProfessor.vue?vue&type=style&index=0&id=dcc28272&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports